import { http } from '@/lib/http';

/** GET /public/branding (anonymous): resolved from the host the CRM is opened on. Mirrors Modules/Identity/TenantBranding.cs. */
export interface PublicBranding {
  /** false = main domain or unknown host → the built-in Nguyên Bình branding. */
  isTenant: boolean;
  tenantName: string;
  displayName: string;
  tagline: string | null;
  /** Public, versioned URL (usable in <img src>), null = no logo. */
  logoUrl: string | null;
  /** "#rrggbb" accent, or null. */
  color: string | null;
}

/** Branding block of `/identity/me` (null for the platform operator). */
export interface TenantBranding {
  displayName: string | null;
  tagline: string | null;
  color: string | null;
  logoUrl: string | null;
}

export const brandingApi = {
  get: () => http.get<PublicBranding>('/public/branding', undefined, { anonymous: true }),
};
